import { PackagesPanelMock } from "./PackagesPanelMock";
import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";

// From the pinned kernel image package lists. Stata is left out on purpose:
// the kernels can read .dta, but the upload dialog doesn't accept it yet.
const LANGUAGES = [
  {
    name: "Python",
    groups: [
      ["Data", "pandas, polars, NumPy, SciPy, pyarrow, Dask"],
      ["Statistics & ML", "statsmodels, scikit-learn, lifelines, scikit-survival, pingouin, XGBoost, LightGBM"],
      ["Charts", "matplotlib, seaborn, Plotly, Bokeh, Altair"],
      ["Files", "SAS and SPSS via pyreadstat, Excel, Parquet, HDF5"],
    ],
  },
  {
    name: "R",
    groups: [
      ["Data", "tidyverse, data.table"],
      ["Statistics", "survival (Kaplan–Meier), table1, epitools, pwr, broom, MASS"],
      ["Charts & tables", "plotly, patchwork, corrplot, pheatmap, gt, DT, kableExtra"],
      ["Files", "SAS and SPSS via haven"],
    ],
  },
];

export function NotebookLibraries() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref}>
      <motion.div style={{ y: fgY }}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#1E4FD8] dark:text-[#4A90D9] mb-3 text-center">Notebook · Libraries</p>
        <h3 className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white text-center max-w-2xl mx-auto mb-4">
          Ready before you are.
        </h3>
        <p className="text-base leading-[1.7] text-[#5C5C66] dark:text-[#9A9A9A] text-center max-w-xl mx-auto mb-12">
          Data wrangling, statistics, machine learning, survival analysis, and charting libraries
          are installed before you start, and you can add anything else you need.
        </p>
      </motion.div>
      <motion.div style={{ y: bgY }} className="max-w-5xl mx-auto">
      <div className="grid md:grid-cols-2 gap-6">
        {LANGUAGES.map(({ name, groups }) => (
          <div key={name} className="rounded-2xl border border-[#0A0A0F]/10 dark:border-white/10 bg-white dark:bg-[#0D0D10] p-8">
            <p className="text-xl font-normal text-[#0A0A0F] dark:text-white mb-6">{name}</p>
            <dl className="space-y-4">
              {groups.map(([label, libs]) => (
                <div key={label}>
                  <dt className="text-xs font-bold uppercase tracking-widest text-[#1E4FD8] dark:text-[#4A90D9] mb-1">{label}</dt>
                  <dd className="font-mono text-xs leading-relaxed text-[#5C5C66] dark:text-[#9A9A9A]">{libs}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
      <PackagesPanelMock />
      </motion.div>
    </div>
  );
}

